/* global grecaptcha */
let forms = document.querySelectorAll("form.email");

for (let form of Array.from(forms)) {

    form.addEventListener("submit", function (e) {
        e.preventDefault();
        let message = e.target.querySelectorAll(".response-output")[0];

        grecaptcha.ready(async function () {
            let token = await grecaptcha.execute(
                "6LdaEuopAAAAAFf_rvULeXfKACalsj-jA90ppUhT",
                {action: "submit"}
            );
            var formData = new FormData(form);
            formData.append("g-recaptcha-response", token);
            formData.append("_url", window.location.href);

            try {
                let response = await fetch("https://forms.trisotech.com/submit", {
                    method: "post",
                    body: formData
                });

                if (response.ok) {
                    form.reset();
                    message.innerHTML =
                        "<strong>Success!</strong> Your message was sucessfully sent.";
                    form.classList.remove("error");
                    form.classList.add("success");
                } else {
                    let txt = await response.text();
                    message.innerHTML =
                        "<strong>Error!</strong> " +
                        txt.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
                    form.classList.add("error");
                    form.classList.remove("success");
                }
            } catch {
                message.innerHTML = "<strong>Error!</strong> Unexpected error, please try again later.";
                form.classList.add("error");
                form.classList.remove("success");
            }

        });
    });
}
